import Image from '@tiptap/extension-image'

export const ResizableImage = Image.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            width: {
                default: null,
                renderHTML: (attributes) => {
                    if (!attributes.width) return {}
                    return { width: attributes.width }
                },
                parseHTML: (element) => element.getAttribute('width'),
            },
            height: {
                default: null,
                renderHTML: (attributes) => {
                    if (!attributes.height) return {}
                    return { height: attributes.height }
                },
                parseHTML: (element) => element.getAttribute('height'),
            },
        }
    },

    addNodeView() {
        return ({ node, getPos, editor }) => {
            const container = document.createElement('div')
            container.style.display = 'inline-block'
            container.style.position = 'relative'
            container.style.lineHeight = '0'
            container.style.maxWidth = '100%'

            const img = document.createElement('img')
            img.src = node.attrs.src
            img.alt = node.attrs.alt || ''
            if (node.attrs.width) img.style.width = `${node.attrs.width}px`
            if (node.attrs.height) img.style.height = `${node.attrs.height}px`
            img.style.maxWidth = '100%'
            img.style.cursor = 'pointer'
            img.style.borderRadius = '4px'

            // Handle de resize no canto inferior direito
            const handle = document.createElement('div')
            handle.style.cssText = `
                position: absolute;
                bottom: 4px;
                right: 4px;
                width: 12px;
                height: 12px;
                background: #3b82f6;
                border-radius: 2px;
                cursor: nwse-resize;
                opacity: 0;
                transition: opacity 0.15s;
            `

            container.addEventListener('mouseenter', () => {
                handle.style.opacity = '1'
                img.style.outline = '2px solid #3b82f6'
                img.style.outlineOffset = '2px'
            })
            container.addEventListener('mouseleave', () => {
                handle.style.opacity = '0'
                img.style.outline = 'none'
            })

            let startX = 0
            let startWidth = 0
            let startHeight = 0

            const onMouseMove = (e: MouseEvent) => {
                const dx = e.clientX - startX
                const aspectRatio = startHeight / startWidth
                const newWidth = Math.max(50, startWidth + dx)
                const newHeight = Math.round(newWidth * aspectRatio)
                img.style.width = `${newWidth}px`
                img.style.height = `${newHeight}px`
            }

            const onMouseUp = () => {
                document.removeEventListener('mousemove', onMouseMove)
                document.removeEventListener('mouseup', onMouseUp)
                const pos = getPos()
                if (pos !== undefined && editor.isEditable) {
                    const width = parseInt(img.style.width)
                    const height = parseInt(img.style.height)
                    editor.chain().focus().updateAttributes('image', { width, height }).run()
                }
            }

            handle.addEventListener('mousedown', (e) => {
                e.preventDefault()
                e.stopPropagation()
                startX = e.clientX
                startWidth = img.offsetWidth
                startHeight = img.offsetHeight
                document.addEventListener('mousemove', onMouseMove)
                document.addEventListener('mouseup', onMouseUp)
            })

            container.appendChild(img)
            container.appendChild(handle)

            return {
                dom: container,
                update: (updatedNode) => {
                    if (updatedNode.type.name !== 'image') return false
                    img.src = updatedNode.attrs.src
                    img.alt = updatedNode.attrs.alt || ''
                    if (updatedNode.attrs.width) img.style.width = `${updatedNode.attrs.width}px`
                    if (updatedNode.attrs.height) img.style.height = `${updatedNode.attrs.height}px`
                    return true
                },
            }
        }
    },
})
